import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Button2 = (props: Props) => {
  const className = `font-raleway-medium text-base ${mapStylesFromProps(props)}`
  return (
    <span className={className}>
      {typeof props.children === "string"
        ? props.children.toUpperCase()
        : props.children}
    </span>
  )
}

export default Button2
